import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { AngularFireAuth } from '@angular/fire/compat/auth';
import { DefaultService } from './api-client-module/';

import { ApiAuthRequest, ApiAuthResponse } from './api-client-module/';
import { ApiSetUsersRequest, ApiSetUsersResponse } from './api-client-module/';
import { ApiSetProjectsRequest, ApiSetProjectsResponse } from './api-client-module/';
import { ApiSetLanguagesRequest, ApiSetLanguagesResponse } from './api-client-module/';
import { ApiSetFacilityAttributesRequest, ApiSetFacilityAttributesResponse } from './api-client-module/';
import { ApiSetExhibitAttributesRequest, ApiSetExhibitAttributesResponse } from './api-client-module/';
import { ApiSetExhibitDetailAttributesRequest, ApiSetExhibitDetailAttributesResponse } from './api-client-module/';
import { ApiSetReservationFacilityAttributesRequest, ApiSetReservationFacilityAttributesResponse } from './api-client-module/';
import { ApiSetFacilitiesRequest, ApiSetFacilitiesResponse } from './api-client-module/';
import { ApiSetExhibitsRequest, ApiSetExhibitsResponse } from './api-client-module/';
import { ApiSetExhibitDetailsRequest, ApiSetExhibitDetailsResponse } from './api-client-module/';
import { ApiSetReservationFacilitiesRequest, ApiSetReservationFacilitiesResponse } from './api-client-module/';
import { ApiSetReservationFacilitySpecialsRequest, ApiSetReservationFacilitySpecialsResponse } from './api-client-module/';
import { ApiSetReservationQuestionsRequest, ApiSetReservationQuestionsResponse } from './api-client-module/';
import { ApiSetReservationsRequest, ApiSetReservationsResponse } from './api-client-module/';
import { ApiSetUploadedFilesRequest, ApiSetUploadedFilesResponse } from './api-client-module/';
import { ApiSetUploadedFilesAttributesRequest, ApiSetUploadedFilesAttributesResponse } from './api-client-module/';
import { ApiSetFloorsRequest, ApiSetFloorsResponse } from './api-client-module/';
import { ApiSetHallsRequest, ApiSetHallsResponse } from './api-client-module/';
import { ApiSetGeneralTextsRequest, ApiSetGeneralTextsResponse } from './api-client-module/';
import { ApiReflectDataRequest, ApiReflectDataResponse } from './api-client-module/';
import { ApiSetReflectDataScheduleRequest, ApiSetReflectDataScheduleResponse } from './api-client-module/';
import { ApiSetNoticesRequest, ApiSetNoticesResponse } from './api-client-module/';
import { ApiSetBoardThreadRequest, ApiSetBoardThreadResponse } from './api-client-module/';
import { ApiSetBoardCommentRequest, ApiSetBoardCommentResponse } from './api-client-module/';
import { ApiSetQuestionsRequest, ApiSetQuestionsResponse } from './api-client-module/';
import { ApiSetQuestSetRequest, ApiSetQuestSetResponse } from './api-client-module/';
import { ApiSetSheltersRequest, ApiSetSheltersResponse } from './api-client-module/';
import { ApiCreateEnqueteDownloadFilesRequest, ApiCreateEnqueteDownloadFilesResponse } from './api-client-module/';
import { ApiCreateReservationDownloadFilesRequest, ApiCreateReservationDownloadFilesResponse } from './api-client-module/';
import { ApiSetReservationsStatusRequest, ApiSetReservationsStatusResponse } from './api-client-module/';
import { ApiSetLotteriesRequest, ApiSetLotteriesResponse } from './api-client-module/';
import { ApiSetFacilityUsersRequest, ApiSetFacilityUsersResponse } from './api-client-module/';
import { ApiSetEntranceExitUsersRequest, ApiSetEntranceExitUsersResponse } from './api-client-module/';
import { ApiSetEntranceExitQuestionsRequest, ApiSetEntranceExitQuestionsResponse } from './api-client-module/';
import { ApiSetEntranceExitEventsRequest, ApiSetEntranceExitEventsResponse } from './api-client-module/';
import { ApiSetEntranceExitEntriesRequest, ApiSetEntranceExitEntriesResponse } from './api-client-module/';
import { ApiSetEntranceExitExhibitTransitDownloadFilesRequest, ApiSetEntranceExitExhibitTransitDownloadFilesResponse } from './api-client-module/';
import { ApiSetSplatsRequest, ApiSetSplatsResponse } from './api-client-module/';
import { ApiGetSplatsKeyDevicesRequest, ApiGetSplatsKeyDevicesResponse } from './api-client-module/';

@Injectable({
  providedIn: 'root'
})
export class ApiClientService {

  constructor(
    private angularFireAuth: AngularFireAuth,
    // private configuration: ConfigurationService,
    private apiService: DefaultService
  ) { }

  /**
  * Firebase Auth の idToken を取得
  *
  */
  private async getIdToken(): Promise<string> {
    let idToken: string = 'dummy';
    if (!!this.angularFireAuth.currentUser) {
      idToken = await this.angularFireAuth.currentUser.then(
        (user: any) => {
          return user!.getIdToken()
        }
      );
    }
    return idToken;
  }

  /**
  * 認証(Firebase カスタムトークン取得)API
  * @param idToken Google Auth認証のidToken
  */
  public async getCustomToken(idToken: string): Promise<ApiAuthResponse | undefined> {
    let request: ApiAuthRequest = {
      token: idToken
    }
    return await firstValueFrom(this.apiService.clientApiAuth(request, 'body'));
  }

  /**
  * ユーザ情報設定API
  * @param request ユーザー情報設定APIリクエスト
  */
  public async setUsers(request: ApiSetUsersRequest): Promise<ApiSetUsersResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetUsers(request, 'body'));
  }

  /**
  * プロジェクト情報設定API
  * @param request プロジェクト情報設定APIリクエスト
  */
  public async setProjects(request: ApiSetProjectsRequest): Promise<ApiSetProjectsResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetProjects(request, 'body'));
  }

  /**
  * 言語情報設定API
  * @param request 言語情報設定APIリクエスト
  */
  public async setLanguages(request: ApiSetLanguagesRequest): Promise<ApiSetLanguagesResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetLanguages(request, 'body'));
  }

  /**
  * ファイル情報設定API
  * @param request ファイル情報設定APIリクエスト
  */
  public async setUploadedFiles(request: ApiSetUploadedFilesRequest): Promise<ApiSetUploadedFilesResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetUploadedFiles(request, 'body'));
  }

  /**
  * アップロードファイル属性設定API
  * @param request アップロードファイル属性設定APIリクエスト
  */
  public async setUploadedFilesAttributes(request: ApiSetUploadedFilesAttributesRequest): Promise<ApiSetUploadedFilesAttributesResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetUploadedFilesAttributes(request, 'body'));
  }

  /**
  * 施設属性設定API
  * @param request 施設属性設定APIリクエスト
  */
  public async setFacilityAttributes(request: ApiSetFacilityAttributesRequest): Promise<ApiSetFacilityAttributesResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetFacilityAttributes(request, 'body'));
  }

  /**
  * 展示属性設定API
  * @param request 展示属性設定APIリクエスト
  */
  public async setExhibitAttributes(request: ApiSetExhibitAttributesRequest): Promise<ApiSetExhibitAttributesResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetExhibitAttributes(request, 'body'));
  }

  /**
  * 展示属性設定API
  * @param request 展示属性設定APIリクエスト
  */
  public async setExhibitDetailAttributes(request: ApiSetExhibitDetailAttributesRequest): Promise<ApiSetExhibitDetailAttributesResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetExhibitDetailAttributes(request, 'body'));
  }

  /**
  * 予約設備属性設定API
  * @param request 予約設備属性設定APIリクエスト
  */
  public async setReservationFacilityAttributes(request: ApiSetReservationFacilityAttributesRequest): Promise<ApiSetReservationFacilityAttributesResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetReservationFacilityAttributes(request, 'body'));
  }

  /**
  * 施設情報設定API
  * @param request 施設情報設定APIリクエスト
  */
  public async setFacilities(request: ApiSetFacilitiesRequest): Promise<ApiSetFacilitiesResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetFacilities(request, 'body'));
  }

  /**
  * 展示情報設定API
  * @param request 展示情報設定APIリクエスト
  */
  public async setExhibits(request: ApiSetExhibitsRequest): Promise<ApiSetExhibitsResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetExhibits(request, 'body'));
  }

  /**
  * 展示詳細情報設定API
  * @param request 展示情報設定APIリクエスト
  */
  public async setExhibitDetails(request: ApiSetExhibitDetailsRequest): Promise<ApiSetExhibitDetailsResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetExhibitDetails(request, 'body'));
  }

  /**
  * 予約設備情報設定API
  * @param request 予約設備情報設定APIリクエスト
  */
  public async setReservationFacilities(request: ApiSetReservationFacilitiesRequest): Promise<ApiSetReservationFacilitiesResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetReservationFacilities(request, 'body'));
  }

  /**
  * 特別営業日情報設定API
  * @param request 特別営業日情報設定APIリクエスト
  */
  public async setReservationFacilitySpecials(request: ApiSetReservationFacilitySpecialsRequest): Promise<ApiSetReservationFacilitySpecialsResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetReservationFacilitySpecials(request, 'body'));
  }

  /**
   * 予約設問設定API
   * @param request 予約設問設定APIリクエスト
   */
  public async setReservationQuestions(request: ApiSetReservationQuestionsRequest): Promise<ApiSetReservationQuestionsResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetReservationQuestions(request, 'body'));
  }

  /**
  * 予約状況設定API
  * @param request 予約設備情報設定APIリクエスト
  */
  public async setReservations(request: ApiSetReservationsRequest): Promise<ApiSetReservationsResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetReservations(request, 'body'));
  }

  /**
  * フロア情報設定API
  * @param request フロア情報設定APIリクエスト
  */
   public async setFloors(request: ApiSetFloorsRequest): Promise<ApiSetFloorsResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetFloors(request, 'body'));
  }

  /**
  * 建物情報設定API
  * @param request 建物情報設定APIリクエスト
  */
   public async setHalls(request: ApiSetHallsRequest): Promise<ApiSetHallsResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetHalls(request, 'body'));
  }

  /**
  * 汎用テキスト情報設定API
  * @param request 汎用テキスト情報設定APIリクエスト
  */
   public async setGeneralTexts(request: ApiSetGeneralTextsRequest): Promise<ApiSetGeneralTextsResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetGeneralTexts(request, 'body'));
  }

  /**
  * 本番データ反映API
  * @param request 本番データ反映APIリクエスト
  */
  public async reflectData(request: ApiReflectDataRequest): Promise<ApiReflectDataResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiReflectData(request, 'body'));
  }

  /**
   * 本番データ反映スケジュール設定API
   * @param request 本番データ反映APIリクエスト
   */
  public async setReflectDataSchedule(request: ApiSetReflectDataScheduleRequest): Promise<ApiSetReflectDataScheduleResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetReflectDataSchedule(request, 'body'));
  }

  /**
   * 通知設定API
   * @param request 通知設定APIリクエスト
   */
  public async setNotices(request: ApiSetNoticesRequest): Promise<ApiSetNoticesResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetNotices(request, 'body'));
  }

  /**
   * 掲示板（スレッド）設定API
   * @param request 掲示板（スレッド）設定API
   */
  public async setBoardThread(request: ApiSetBoardThreadRequest): Promise<ApiSetBoardThreadResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetBoardThread(request, 'body'));
  }

  /**
   * 掲示板（コメント）設定API
   * @param request 掲示板（コメント）設定API
   */
  public async setBoardComment(request: ApiSetBoardCommentRequest): Promise<ApiSetBoardCommentResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetBoardComment(request, 'body'));
  }

  /**
   * 設問情報設定API
   * @param request 設問情報設定APIリクエスト
   */
   public async setQuestions(request: ApiSetQuestionsRequest): Promise<ApiSetQuestionsResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetQuestions(request, 'body'));
  }

  /**
   * 設問セット情報保存API
   * @param request 設問セット情報保存APIリクエスト
   */
  public async setQuestSet(request: ApiSetQuestSetRequest): Promise<ApiSetQuestSetResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetQuestSet(request, 'body'));
  }

  /**
   * 避難所情報設定API
   * @param request 避難所情報設定APIリクエスト
   */
  public async setShelters(request: ApiSetSheltersRequest): Promise<ApiSetSheltersResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetShelters(request, 'body'));
  }

  /**
   * アンケートダウンロードファイル作成API
   * @param request アンケートダウンロードファイル作成APIリクエスト
   */
  public async createEnqueteDownloadFiles(request: ApiCreateEnqueteDownloadFilesRequest): Promise<ApiCreateEnqueteDownloadFilesResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiCreateEnqueteDownloadFiles(request, 'body'));
  }

  /**
   * 予約ダウンロードファイル作成API
   * @param request 予約ダウンロードファイル作成APIリクエスト
   */
    public async createReservationDownloadFiles(request: ApiCreateReservationDownloadFilesRequest): Promise<ApiCreateReservationDownloadFilesResponse | undefined> {
      const idToken: string = await this.getIdToken();
      request.access_token = idToken;
      return await firstValueFrom(this.apiService.clientApiCreateReservationDownloadFiles(request, 'body'));
    }

  /**
   * 予約情報予約状態変更API
   * @param request 予約情報予約状態変更APIリクエスト
   */
  public async setReservationsStatus(request: ApiSetReservationsStatusRequest): Promise<ApiSetReservationsStatusResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetReservationsStatus(request, 'body'));
  }

  /**
   * 抽選情報設定API
   * @param request 抽選情報設定APIリクエスト
   */
  public async setLotteries(request: ApiSetLotteriesRequest): Promise<ApiSetLotteriesResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetLotteries(request, 'body'));
  }

  /**
  * 施設職員情報設定API
  * @param request 施設職員情報設定APIリクエスト
  */
  public async setFacilityUsers(request: ApiSetFacilityUsersRequest): Promise<ApiSetFacilityUsersResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetFacilityUsers(request, 'body'));
  }

  /**
  * 入退場管理スタッフ情報設定API
  * @param request 入退場管理スタッフ情報設定APIリクエスト
  */
  public async setEntranceExitUsers(request: ApiSetEntranceExitUsersRequest): Promise<ApiSetEntranceExitUsersResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetEntranceExitUsers(request, 'body'));
  }

  /**
  * 入退場管理設問情報設定API
  * @param request 入退場管理設問情報設定APIリクエスト
  */
  public async setEntranceExitQuestions(request: ApiSetEntranceExitQuestionsRequest): Promise<ApiSetEntranceExitQuestionsResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetEntranceExitQuestions(request, 'body'));
  }

  /**
  * 入退場管理イベント情報設定API
  * @param request 入退場管理イベント情報設定APIリクエスト
  */
  public async setEntranceExitEvents(request: ApiSetEntranceExitEventsRequest): Promise<ApiSetEntranceExitEventsResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetEntranceExitEvents(request, 'body'));
  }

  /**
  * 入退場管理エントリー情報設定API
  * @param request 入退場管理エントリー情報設定APIリクエスト
  */
  public async setEntranceExitEntries(request: ApiSetEntranceExitEntriesRequest): Promise<ApiSetEntranceExitEntriesResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetEntranceExitEntries(request, 'body'));
  }

  /**
   * 入退場管理展示来場状況ダウンロードファイル設定API
   * @param request 入退場管理展示来場状況ダウンロードファイル設定APIリクエスト
   */
  public async setEntranceExitExhibitTransitDownloadFiles(request: ApiSetEntranceExitExhibitTransitDownloadFilesRequest): Promise<ApiSetEntranceExitExhibitTransitDownloadFilesResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetEntranceExitExhibitTransitDownloadFiles(request, 'body'));
  }

  /**
   * SPLATS情報設定API
   * @param request SPLATS情報設定APIリクエスト
   */
  public async setSplats(request: ApiSetSplatsRequest): Promise<ApiSetSplatsResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiSetSplats(request, 'body'));
  }

  /**
   * SPLATSキーデバイス情報取得API
   * @param request SPLATSキーデバイス情報取得APIリクエスト
   */
  public async getSplatsKeyDevices(request: ApiGetSplatsKeyDevicesRequest): Promise<ApiGetSplatsKeyDevicesResponse | undefined> {
    const idToken: string = await this.getIdToken();
    request.access_token = idToken;
    return await firstValueFrom(this.apiService.clientApiGetSplatsKeyDevices(request, 'body'));
  }
}
